import { clientTransformed } from '@common/utils/rest';

const URL_PREFIX = 'api/invites';

const getUrl = (path) => {
  return `${URL_PREFIX}/${path}`;
};

export const getInvitesColumns = () => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'GET'
  }).then(
    (response) => {
      return response.entity;
    },
  );
};

export const saveInvitesColumns = (columns) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: columns,
  });
};

export const getInvites = async ({ filtering, pagination }) => {
	return clientTransformed({
    path: getUrl('smartlist'),
    method: 'POST',
		entity: {
			...filtering,
			...pagination,
		},
  }).then(
    (response) => {
      return response.entity;
    },
  );
};